// extracted by mini-css-extract-plugin
export default {"iris_wipe":"Iris_iris_wipe__tnKw0","animateIris":"Iris_animateIris__kvGqL"};